import { Component, Input, OnInit } from '@angular/core';

import { PageNode } from '../../../common/services';


@Component({
  selector: 'p8-bdc-category',
  templateUrl: './category.component.html',
  styleUrls: ['./category.component.scss']
})
export class CategoryComponent implements OnInit {
  @Input() category: PageNode;

  constructor() { }

  ngOnInit() {
  }
}
